/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */

import DbBaseObject from "@shared/DbBaseObject";
import QwoachFile from "@shared/Drive/QwoachFile";

export default class SignatureItem extends DbBaseObject{

	file: QwoachFile = null

	constructor(file = null) {
		super();
		this.file = file
	}


}
